import { AriaAction, AriaContextState, AnimationType } from '@/types';

export const initialState: AriaContextState = {
  isActive: false,
  isMinimized: false,
  isProcessing: false,
  voiceEnabled: false,
  voiceState: {
    isAvailable: false,
    isMicrophoneAvailable: false,
    isProcessing: false,
    isSpeaking: false
  },
  volume: 1,
  sessionId: '',
  error: null,
  messages: [],
  config: {
    animation: {
      currentState: 'idle' as AnimationType,
      previousState: undefined,
      isPlaying: false,
      format: 'video',
      currentSource: null
    },
    voice: {
      enabled: false,
      rate: 1,
      pitch: 1,
      volume: 1
    }
  }
};

export const ariaReducer = (state: AriaContextState = initialState, action: AriaAction): AriaContextState => {
  switch (action.type) {
    case 'SET_ACTIVE':
      return { ...state, isActive: action.payload };
    
    case 'SET_MINIMIZED':
      return { ...state, isMinimized: action.payload };
    
    case 'SET_ANIMATION':
      return {
        ...state,
        config: {
          ...state.config,
          animation: {
            ...state.config.animation,
            currentState: action.payload,
            previousState: state.config.animation.currentState,
            isPlaying: true
          }
        }
      };
    
    case 'SET_VOICE_STATE':
      return {
        ...state,
        voiceState: {
          ...state.voiceState,
          ...action.payload
        }
      };
    
    case 'SET_VOICE_ENABLED':
      return { ...state, voiceEnabled: action.payload };
    
    case 'SET_VOLUME':
      return { ...state, volume: action.payload };
    
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    
    case 'ADD_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };
    
    default:
      return state;
  }
};

export default ariaReducer;